<template>
  <!-- 下载次数上限-提示 -->
  <van-overlay :show="show">
    <div class="share-download" @click.stop>
      <div class="share-download__title">分享后即刻下载</div>
      <div class="share-download__center">只需将本文分享给朋友圈或者好友，完成后马上下载！</div>
      <div class="share-download__footer">
        <button @click.stop="share">立即分享</button>
      </div>
    </div>
    <van-icon class="close-icon" name="close" @click.stop="show = false"/>
  </van-overlay>
</template>

<script>
export default {
  name: 'share_guide_dialog',
  data () {
    return {
      show: false,
      bizId: null,
      activeId: null
    }
  },
  methods: {
    share () {
      this.$emit('callback', true)
      this.show = false
    },
    shareFinish () {
      this.$router.push(`/shareFinish/${this.bizId}/${this.activeId}.html`)
      this.show = false
    }
  }
}
</script>

<style lang="scss" scoped>

  .van-overlay{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .share-download{
      width:250px;
      height:204px;
      background:rgba(255,255,255,1);
      border-radius:6px;
      &__title{
        border-bottom: 1px solid #EBEBEB;
        font-size:17px;
        font-weight:bold;
        color:rgba(3,3,3,1);
        height: 40px;
        line-height: 40px;
        text-align: center;
      }
      &__center{
        font-size:14px;
        color:rgba(3,3,3,1);
        line-height:20px;
        text-align: center;
        margin-bottom: 26px;
        margin-top: 29px;
        padding: 0 13px;
        box-sizing: border-box;
      }
      &__footer{
        margin-bottom: 23px;
        text-align: center;
        button{
          width:179px;
          height:44px;
          background:rgba(47,123,255,1);
          border-radius:22px;
          border:none;
          font-size:17px;
          font-weight: bold;
          color:rgba(255,255,255,1);
        }
      }
    }
    .close-icon{
      margin-top: 18px;
      font-size: 26px;
      color: #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/solutions/template/share_guide_dialog.vue